import React, { useEffect, useState } from "react";
import LibraryBox from "./LibraryBox";
import axios from "../../axios";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { Checkbox, FormControlLabel } from "@mui/material";

const LibraryPropsBox = ({
  filter,
  setFilter,
  selectedQuestion,
  setSelectedQuestion,
  libraryQuestions,
  setLibraryQuestions,
  setSelQueID,
  selQueID,
  questions,
  getquestiondata,
  assessmentDetails,
  sourceLibrary,
  componentType,
  // setIsInProgress,
  // isInProgress,
  addTopics,
  isSelectChecked,
  hideSelectBox,
  sourceQsBank,
  questionTypeMap,
  setQuestionTypeMap,
  selectedBox,
  // qsBankNameData
  // isChecked,
  // setIsChecked
}) => {
  const {
    domain,
    skill,
    bookChapter,
    standard,
    section,
    subject,
    difficultyLevel,
    page,
    limit,
    qsBankNameData,
  } = filter;
  const [isInProgress, setIsInProgress] = useState(false);

  const isAdaptive =
    selectedBox === "adaptive" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive ||
    selectedBox?.autoEvaluate;

  const filterOnlyMCQ = (data = []) => {
    console.log(data, "data to filter mcq");
    if (!isAdaptive) return data;

    return data.filter(
      (q) =>
        q?.type_id?.isManuallyGraded === false ||
        q?.type?.is_manually_graded === false,
    );
  };

  console.log(selectedBox, "SelctedBox");

  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  console.log("question in school id", schoolId);
  const getSchoolLibraryQuestionList = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.get(
        `/api/v1/question/filter?_page=${page}&_limit=${limit}&standardId=${standard?.id}&sectionId=${section?.id}&subjectId=${subject?.id}` +
          `${bookChapter?.bookId ? `&bookId=${bookChapter?.bookId}` : ``}` +
          `${
            bookChapter?.bookId ? `&chapterId=${bookChapter?.chapterId}` : ``
          }` +
          `${domain?.id ? `&domainId=${domain?.id}` : ``}` +
          `${skill?.id ? `&skillId=${skill?.id}` : ``}` +
          `${
            difficultyLevel ? `&difficultyLevelId=${difficultyLevel?.id}` : ``
          }`,
      );
      console.log("res?.data?.dataSchool", res?.data?.data);
      // res && setLibraryQuestions((prev) => [...prev, ...res.data.data]);
      if (res && res.data.data && questions && questions.length > 0) {
        // const filteredQuestions = res.data.data.filter(
        //     (question) => !questions.some((q) => q.id === question.id)
        // );
        // if (filteredQuestions && filteredQuestions.length > 0 && selQueID.length == 0) {
        //     for (const question of filteredQuestions) {
        //         localStorage.removeItem(`isChecked_${question?.id}`);
        //     }
        // }
        setLibraryQuestions(filterOnlyMCQ(res.data.data));
      } else {
        res && setLibraryQuestions(filterOnlyMCQ(res.data.data));
      }
      setIsInProgress(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsInProgress(false);
    }
  };
  const getQuestionBankList = async () => {
    try {
      if (!qsBankNameData?.id) return; // Prevents unnecessary API calls
      const res = await axios.get(
        `/api/v1/questionbank/getById/${qsBankNameData.id}`,
      );
      if (res && res.data.data.questions.length > 0) {
        // const filteredQuestions = res.data.data.filter(
        //     (question) => !questions.some((q) => q.b4sQuestion === question.id)
        // );
        // if (filteredQuestions.length > 0 && selQueID.length === 0) {
        //     for (const question of filteredQuestions) {
        //         localStorage.removeItem(`isChecked_${question?.id}`);
        //     }
        // }

        setLibraryQuestions(filterOnlyMCQ(res?.data?.data?.questions));
      } else {
        setLibraryQuestions([]);
      }
    } catch (error) {
      console.error("Error fetching question bank:", error);
    }
  };

  const getB4SLibraryQuestionList = async () => {
    setIsInProgress(true);

    try {
      const baseUrl = `/api/v1/b4sQuestion/filter`;

      const queryParams =
        `?_page=${page}` +
        `&_limit=${limit}` +
        `&standardId=${standard?.id}` +
        `&sectionId=${section?.id}` +
        `&subjectId=${subject?.id}` +
        `${bookChapter?.bookId ? `&bookId=${bookChapter.bookId}` : ``}` +
        `${bookChapter?.chapterId ? `&chapterId=${bookChapter.chapterId}` : ``}` +
        `${domain?.id ? `&domainId=${domain.id}` : ``}` +
        `${skill?.id ? `&skillId=${skill.id}` : ``}` +
        `${difficultyLevel?.id ? `&difficultyLevelId=${difficultyLevel.id}` : ``}`;

      const finalUrl = baseUrl + queryParams;

      // 🔥 PRINT FINAL URL
      console.log("📌 FINAL API URL:", finalUrl);

      let res = await axios.get(finalUrl);

      // 🔥 PRINT FULL RESPONSE
      console.log("📦 FULL RESPONSE:", res);

      // 🔥 PRINT DATA ONLY
      console.log("📊 res?.data?.data:", res?.data?.data);

      if (res && res.data && res.data.data) {
        setLibraryQuestions(filterOnlyMCQ(res.data.data));
      } else {
        setLibraryQuestions([]);
      }

      getquestiondata(res);
    } catch (error) {
      console.log("❌ API ERROR:", error);
      console.log("❌ ERROR RESPONSE:", error?.response);
    } finally {
      setIsInProgress(false);
    }
  };

  useEffect(() => {
    if (sourceLibrary === "FROM_SCHOOL_LIBRARY") {
      if (qsBankNameData && qsBankNameData.id) {
        // Ensure valid data
        getQuestionBankList();
      } else {
        getSchoolLibraryQuestionList();
      }
    } else if (sourceLibrary === "FROM_B4S_LIBRARY") {
      getB4SLibraryQuestionList();
    }
  }, [
    qsBankNameData,
    domain,
    skill,
    bookChapter,
    difficultyLevel,
    questions,
    sourceLibrary,
  ]);

  useEffect(() => {
    const fetchQuestionTypes = async () => {
      try {
        const res = await axios.get(
          `/api/v1/questionType/get/school/${schoolId}`,
        );

        const map = {};
        res.data?.data?.forEach((val) => {
          if (val?.b4sQuestionType && !map[val.b4sQuestionType]) {
            map[val.b4sQuestionType] = val;
          }
        });

        setQuestionTypeMap(map);
      } catch (error) {
        console.log("Error fetching question types", error);
      }
    };

    fetchQuestionTypes();
  }, [schoolId]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("total-assessment-library-question")
          .clientHeight +
          document.getElementById("total-assessment-library-question")
            .scrollTop +
          1 >=
        document.getElementById("total-assessment-library-question")
          .scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById(
      "total-assessment-library-question",
    );
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      {libraryQuestions?.length > 0 ? (
        <div
          id="total-assessment-library-question"
          className="d-flex gap-3 flex-wrap align-items-center justify-content-center"
        >
          {libraryQuestions.map((question, index) => {
            const addTo = question.add_to;

            const shouldRender =
              addTo === "all" ||
              (addTo === "homework" &&
                componentType === ComponentType.HOMEWORK) ||
              (addTo === "assessment" &&
                componentType === ComponentType.ASSESSMENT) ||
              (addTo !== "homework" &&
                addTo !== "assessment" &&
                addTo !== "all");

            return shouldRender ? (
              <LibraryBox
                key={index}
                question={question}
                selectedQuestion={selectedQuestion}
                setSelectedQuestion={setSelectedQuestion}
                libraryQuestions={libraryQuestions}
                setSelQueID={setSelQueID}
                assessmentDetails={assessmentDetails}
                sourceLibrary={sourceLibrary}
                componentType={componentType}
                isSelectChecked={isSelectChecked}
                hideSelectBox={hideSelectBox}
                questionTypeMap={questionTypeMap}
                // Optional: inform child about type
                // boxType={
                //   question.add_to === 'homework' ? 'homework' : 'assessment'
                // }
              />
            ) : null;
          })}
        </div>
      ) : isInProgress ? (
        <div style={{ width: "100vw" }}>
          <img
            style={{ marginLeft: "45%", width: "80px", height: "70px" }}
            className="ongoing_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <span>Questions Not Found</span>
      )}
    </>
  );
};

export default LibraryPropsBox;
